import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";
import { lazy } from "react";

const CreateDeliveryNotePageContent = lazy(() => import("./CreateDeliveryNotePageContent"));

function CreateDeliveryNotePageInternal() {
    return (
        <DefaultPage>
            <CreateDeliveryNotePageContent />
        </DefaultPage>
    );
}

export const CreateDeliveryNotePage = withAuthorization(
    getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER, Role.EMPLOYEE, Role.TEMPORARY_WORKER)
)(CreateDeliveryNotePageInternal);
